import React from 'react';
import { Link } from 'react-router-dom';
import './Partnership.css';

function Partnership() {
  return (
    <div className="partnership-page-wrapper">
      {/* Partnership Hero Banner Section */}
      <div className="partnership-hero">
        <div className="partnership-hero-overlay"></div>
        <div className="partnership-hero-content">
          <h2>Partnership</h2>
        </div>
      </div>

      {/* Main Content Section */}
      <div className="partnership-content-section">
        <div className="partnership-breadcrumb-container">
          <Link to="/" onClick={() => window.scrollTo(0,0)} className="breadcrumb-home" style={{ textDecoration: 'none' }}>Home</Link>
          <span className="breadcrumb-separator"> / </span>
          <span className="breadcrumb-current">Become a merchant</span>
        </div>

        {/* Content detail layout */}
        <div className="partnership-main-grid">
          <div className="partnership-left-text-section">
            <h1 className="partnership-headline">Become a <span className="green-accent">ZustGo Merchant Partner</span></h1>
            <div className="partnership-description-paragraphs">
              <p>Expand your business reach and double your sales by partnering with ZustGo. We provide restaurant owners, grocery vendors, and local merchants with a robust platform to list their products, connect with thousands of local customers, and manage deliveries effortlessly.</p>
              <p>By listing your store on the ZustGo app, you unlock a steady stream of online orders without having to manage delivery logistics. Our professional, fast, and secure delivery network ensures that your products reach your customers fresh and on time, every single day.</p>
              <p>We provide merchants with an intuitive dashboard to track orders in real-time, update menus or inventory instantly, and analyze sales performance. With flexible payout structures and 24/7 dedicated partner support, we make online selling simple, profitable, and reliable.</p>
              <p>Ready to grow your restaurant or retail store? Download the ZustGo Merchant App or fill out our sign-up form today, and start serving online customers in your city within hours!</p>
            </div>
            <button className="partnership-action-btn">Register Your Store</button>
          </div>

          <div className="partnership-right-visual-section">
            <div className="partnership-card-container">
              <div className="partnership-benefit-card">
                <div className="benefit-icon">📈</div>
                <h3>Increase Sales</h3>
                <p>Reach new digital customers in your area and boost your order volume daily.</p>
              </div>
              <div className="partnership-benefit-card">
                <div className="benefit-icon">🚚</div>
                <h3>Hassle-Free Delivery</h3>
                <p>Our professional delivery fleet handles all logistics while you focus on cooking or packaging.</p>
              </div>
              <div className="partnership-benefit-card">
                <div className="benefit-icon">📊</div>
                <h3>Real-time Analytics</h3>
                <p>Track your business growth, view detailed sales reports, and customize operations on the fly.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Partnership;